import { getLocation, routes } from "@src/appV2/redesign/utils/routes";
import { NavigationItem } from "./types";

export function getRouteAndSelected(
  route: keyof typeof routes,
  currentPath: string
): Pick<NavigationItem, "routeTo" | "isSelected"> {
  const routeTo = getLocation(route);
  return {
    routeTo,
    isSelected: routeTo.pathname ? currentPath.includes(routeTo.pathname) : false,
  };
}
